import firebase from 'firebase/app'

import * as crud from './crud'


const getCountData = async () => {
  const db = firebase.firestore()
  const users = await crud.get(db.collection('data').doc('users'))
  const shops = await crud.get(db.collection('data').doc('shops'))
  const orders = await crud.get(db.collection('data').doc('orders'))
  const transactions = await crud.get(db.collection('data').doc('transactions'))

  return {
    users: users ? users.value : 0,
    shops: shops ? shops.value : 0,
    orders: orders ? orders.value : 0,
    transactions: transactions ? transactions.value : 0,
  }
}


export default getCountData
